import { createContext } from 'react';

export const DefaultConfig = {
  type: '',
  other_timeline: '',
  words: [],
  style: 'twitter',
  font: 'system',
  animation: 'simple',
  display: 'text',
  duration: 10,
  display_retweets: true,
  display_replies: true,
  display_links: true,
  filter: 'manual',
  background_color: '',
  bubble_color: '',
  logo_color: '',
  text_color: '',
  name_color: '',
  username_color: '',
  time_window: 0,
  date_color: '',
  animation_color_1: 'rgba(255,255,255,0.8)',
  animation_color_2: 'rgba(228,112,30,0.8)',
  animation_color_3: 'rgba(228,112,30,0.8)'
};

export default createContext(DefaultConfig);
